import React, { useMemo } from 'react';

import { RawIntlProvider } from 'react-intl';
import { syncAppIntl } from 'i18n/appIntl';

type LocalizedIntlProviderProps = {
    children: React.ReactNode;
    cultureTag: string;
};

/**
 * The app's sole react-intl provider. Must wrap the ENTIRE tree rendered from
 * the root — including shell chrome like toasts and loaders that mount before
 * the app context finishes loading — so no intl consumer can ever render
 * outside it. Also keeps the module-level intl (i18n/appIntl) in sync for
 * code that runs outside the React tree.
 */
export const LocalizedIntlProvider = (props: LocalizedIntlProviderProps) => {

    const { children, cultureTag } = props;

    const intl = useMemo(() => syncAppIntl(cultureTag), [cultureTag]);

    return (
        <RawIntlProvider value={intl}>
            {children}
        </RawIntlProvider>
    );

};
